import CrmDealsAPI from '../../api/saas/crmDeals';

const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
  },
};

const getters = {
  getDeals($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getDealsByStage: $state => stageId => {
    return $state.records.filter(
      deal => deal.saas_pipeline_stage_id === stageId
    );
  },
};

const actions = {
  async get({ commit }, params = {}) {
    commit('SET_CRM_DEALS_UI_FLAG', { isFetching: true });
    try {
      const response = await CrmDealsAPI.get(params);
      commit('SET_CRM_DEALS', response.data.payload || []);
      commit('SET_CRM_DEALS_META', response.data.meta || {});
      return response.data;
    } finally {
      commit('SET_CRM_DEALS_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, data) {
    commit('SET_CRM_DEALS_UI_FLAG', { isCreating: true });
    try {
      const response = await CrmDealsAPI.create(data);
      commit('ADD_CRM_DEAL', response.data);
      return response.data;
    } finally {
      commit('SET_CRM_DEALS_UI_FLAG', { isCreating: false });
    }
  },
  async move({ commit }, { id, ...data }) {
    commit('SET_CRM_DEALS_UI_FLAG', { isUpdating: true });
    try {
      const response = await CrmDealsAPI.move(id, data);
      commit('UPDATE_CRM_DEAL', response.data);
      return response.data;
    } finally {
      commit('SET_CRM_DEALS_UI_FLAG', { isUpdating: false });
    }
  },
};

const mutations = {
  SET_CRM_DEALS_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_CRM_DEALS($state, data) {
    $state.records = data;
  },
  SET_CRM_DEALS_META($state, data) {
    $state.meta = data;
  },
  ADD_CRM_DEAL($state, data) {
    const exists = $state.records.some(deal => deal.id === data.id);
    if (!exists) $state.records.push(data);
  },
  UPDATE_CRM_DEAL($state, data) {
    const idx = $state.records.findIndex(deal => deal.id === data.id);
    if (idx === -1) {
      $state.records.push(data);
    } else {
      $state.records.splice(idx, 1, data);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
